// extracted by mini-css-extract-plugin
export var icon = "_be-3";
export var subtitle = "_be-2";
export var title = "_be-1";
export var value = "_be-0";